import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Badge, Box, Typography } from "@mui/material";
import { NAVIGATION_SECTIONS } from "../constants";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";
import { toggleMobileCouponDrawer } from "redux/coupon/couponSlice";

interface NavLinksProps {
  handleLeftDrawer?: () => void;
}

export default function GamingLinksv1({
  handleLeftDrawer,
}: NavLinksProps): ReactElement {
  const dispatch = useAppDispatch()
  const couponLength = useAppSelector(state => state.coupon.couponLength)
  const active = useAppSelector((state) => state.navigation.activeRoute);
  const isAuth = useAppSelector((state) => state.auth.isAuth)
  const images = require.context(
    "assets/images/header",
    true,
    /\.(png|ico|svg|jpg|gif)$/
  );
  const filteredItems =
    process.env.REACT_APP_HIDE_LIVE_SPORT === 'true' ?
      NAVIGATION_SECTIONS.filter(item => !item.isHideable)
      :
      NAVIGATION_SECTIONS;

  const handleCouponClick = () => {
    dispatch(toggleMobileCouponDrawer(true));
  };

  return (
    <div className={`${styles.gameLinksContainer} ${isAuth && styles.marginRight}`}>
      {filteredItems?.map((item, index) => (
        <>
          {!process.env.REACT_APP_EXCLUDED_ROUTES?.includes(item.label.toLowerCase()) &&
            <Box
              key={index}
              className={`${styles.gameLinkItem} ${active === item.id && styles.activeGameLinkItem
                } ${item.visibleFor === "desktop"
                  ? styles.displayForDesktop
                  : item.visibleFor === "mobile"
                    ? styles.displayForMobile
                    : styles.gameLinkItem
                } `}
            >
              {item.section === "coupon" ?
                <Box
                  onClick={handleCouponClick}
                  className={styles.gameLink}
                >
                  <Badge badgeContent={couponLength} color="primary" className={styles.badge}>
                    <Typography className={styles.itemLabel}>{item.label}</Typography>
                  </Badge>
                </Box>
                :
                <Box
                  component={Link}
                  to={item.path}
                  onClick={handleLeftDrawer && handleLeftDrawer}
                  className={styles.gameLink}
                >
                  {process.env.REACT_APP_HEADER_ICON === "true" &&
                    <img
                      src={images(`./${item.section}.svg`).default}
                      alt={item.section}
                      className={styles.gameLinkImg}
                    />}
                  <Typography className={styles.itemLabel}>{item.label}</Typography>
                </Box>
              }
            </Box>
          }
        </>
      ))}
    </div>
  );
}
